/**
 * Manual "Refresh" is offered when the EFFECTIVE refresh strategy (own strategy, or the campaign
 * override that wins over it) is Manual or Dynamic. AutoDaily lists refresh overnight; Locked lists
 * are frozen. Dynamic stays refreshable because the backend has no Dynamic consumer, so a Dynamic
 * list is a snapshot from its last save and hiding Refresh would freeze it. UX-only gate.
 */
export function canManuallyRefresh(list: { effectiveRefreshStrategy?: string; refreshStrategy: string }): boolean {
  const s = list.effectiveRefreshStrategy ?? list.refreshStrategy
  return s === 'Manual' || s === 'Dynamic'
}

export function canManuallyRefreshCampaign(override: string | null | undefined): boolean {
  return override === 'Manual'
}

export function isAutoDaily(list: { effectiveRefreshStrategy?: string; refreshStrategy: string }): boolean {
  return (list.effectiveRefreshStrategy ?? list.refreshStrategy) === 'AutoDaily'
}
